import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
	STR__MENU_BOOKINGS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NO_ORDERS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import OneRoomOrder from '../ones/OneRoomOrder'
import WelcomeSlider from "../ones/WelcomeSlider";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			appContext.getAllRoomOrders(),
		])
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">
						<div className="col-md-12">
							<WelcomeSlider/>
						</div>
						
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								{STR__MENU_BOOKINGS[appContext.language]}
							</h6>
						</div>
						

						{
							(appContext.allRoomOrders && appContext.allRoomOrders.length > 0) ?
							appContext.allRoomOrders.map((item, i) => {
								return (
									<div className="col-md-12" key={i}>
										<OneRoomOrder data={item} />
									</div>
								)
							})
							:
							<div className="col-md-12">
								<h6>{STR_NO_ORDERS[appContext.language]}</h6>
							</div>
						}

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}